import React from 'react';

const DeleteTitleConfirmation = ({ open, title, isDeleting, onCancel, onConfirm }) => {
    if (!open) return null;

    return (
        <div
            role="presentation"
            style={{ position: 'fixed', inset: 0, zIndex: 1300, display: 'grid', placeItems: 'center', padding: 16, background: 'rgba(15, 23, 42, 0.48)' }}
            onMouseDown={onCancel}
        >
            <section
                role="dialog"
                aria-modal="true"
                aria-labelledby="delete-title-heading"
                style={{ width: 'min(100%, 440px)', borderRadius: 12, background: '#fff', padding: 24, boxShadow: '0 24px 48px rgba(15, 23, 42, 0.24)' }}
                onMouseDown={(event) => event.stopPropagation()}
            >
                <h2 id="delete-title-heading" style={{ margin: 0, color: '#1e293b', fontSize: 20 }}>Delete popular title?</h2>
                <p style={{ margin: '10px 0 20px', color: '#475569', lineHeight: 1.5 }}>
                    <strong>{title || 'This title'}</strong> and all products selected under it will be removed from the homepage.
                </p>
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
                    <button type="button" onClick={onCancel} disabled={isDeleting} style={{ border: '1px solid #cbd5e1', borderRadius: 6, background: '#fff', color: '#334155', padding: '10px 14px', cursor: 'pointer' }}>
                        Cancel
                    </button>
                    <button type="button" onClick={onConfirm} disabled={isDeleting} style={{ border: 0, borderRadius: 6, background: '#dc2626', color: '#fff', padding: '10px 14px', cursor: 'pointer' }}>
                        {isDeleting ? 'Deleting…' : 'Delete title'}
                    </button>
                </div>
            </section>
        </div>
    );
};

export default DeleteTitleConfirmation;
